import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 删除挂单
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function deleteStoreOrderUp(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/deleteStoreOrderUp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}